import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import "../styles/Dashboard.css"
import { useNavigate } from "react-router-dom";

const Dashboard: React.FC = () => {
  const { logout, token } = useAuth();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({});
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          "https://uragate.in/websites/springapi/driver-registration/v1/account",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setData(response.data);
      } catch (err: any) {
        console.error(err)
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token, logout]);

  if (loading) {
    return (
      <div className="dashboad-loading-page">
        <p>Loging in....</p>
      </div>
    )
  }

  if (!data) {
    return (
      <div className="dashboad-loading-page">
        <p>Something went wrong.</p>
      </div>
    )
  }

  return (
    <div className="dashboad-page">
      <div className="spacer"></div>
      <div className="dashboard-main-container">
        <h1 className="welcome-text">Welcome, {data?.driverName}</h1>
        <div className="dashboard-section">
          <p className="section-title">Profile</p>
          <div className="section-content">
            <div className="section-item">
              <p>ID:</p>
              <p>{data?.driverId}</p>
            </div>
            <div className="section-item">
              <p>Name:</p>
              <p>{data?.driverName}</p>
            </div>
            <div className="section-item">
              <p>Contact:</p>
              <p>{data?.driverContact}</p>
            </div>
            <div className="section-item">
              <p>Alt contact:</p>
              <p>{data?.altDriverContact}</p>
            </div>
            <div className="section-item">
              <p>Upi:</p>
              <p>{data?.driverUpiId}</p>
            </div>
            <div className="section-item">
              <p>Vehicle reg. no:</p>
              <p>{data?.cabNumber}</p>
            </div>
          </div>
        </div>

        <div className="dashboard-section">
          <p className="section-title">Service</p>
          <div className="section-content">
            <div className="section-item">
              <p>Region:</p>
              <p>{data?.operationServiceName}</p>
            </div>
            <div className="section-item">
              <p>Service Type:</p>
              <p>{data?.serviceName}</p>
            </div>
            <div className="section-item">
              <p>Vehicle Category:</p>
              <p>{data?.mediumType}</p>
            </div>
          </div>
        </div>
        <button className="file-upload-btn" onClick={() => navigate('/upload')}>File</button>
        <button className="logout-btn" onClick={logout}>Logout</button>
      </div>
      <div className="spacer"></div>
    </div>
  );
};

export default Dashboard;
